<template>
  <div class="TasksEditor">
    <div>
      <!--v-if="bIsEdit"-->
      <div class="TasksEditor bntGroup">
        <base-button @click="GoToEdit(false)" type="primary" class="no-border my-0" simple icon>
          <i class="d-inline-block tim-icons icon-simple-remove"></i>
        </base-button>
      </div>

      <ReTasksEdit  />

    </div>
  </div>
</template>
<script>
import ReTasksEdit from "src/our_components/TasksView/ReTasksEdit.vue";

export default {
  name: "tasks_editor-page",
  components: {
      ReTasksEdit,
  },
  data() {
    return {
      ApiData: {},
      bIsEdit: false,
      
    };
  },
  methods: {
    getApiData() {
      this.$GVO
        .ApiCall("GET", { obj: "template" })
        .then(objApi => {
          if (objApi.success === true) {
            if (objApi.data.length > 0) {
              this.ApiData = objApi.data;
            }
          }
        })
        .catch(errorObjApi => console.error(errorObjApi));
    },
/*
    GoToEdit(bGoEdit = true) {
      //this.bIsEdit = bGo;
      if (bGoEdit) {
        this.$router.push({
          path:
            "/data/line/channel/id/" + this.$route.params.channel_id + "/edit"
        });
      } else {
        this.$router.push({ path: "/data/line/" });
      } 
    }*/
  },
  mounted() {
    this.getApiData();
  }
};
</script>
<style scoped>
.TasksEditor.bntGroup {
  position: absolute;
  z-index: 1;
  right: 40px;
}
</style>
